/* eslint-disable */
/* eslint-disable camelcase */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import swal from 'sweetalert';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import moment from 'moment';
// material
import { Table, TableRow, TableBody, TableCell, TableContainer, Stack } from '@mui/material';
import Page from '../../../components/Page';
import Scrollbar from '../../../components/Scrollbar';
import TrainingEventCalender from './TrainingEventCalender';
import { EventCalendarListHead, EventCalendarListToolbar } from '../../../sections/@dashboard/eventCalendar';
import {
  getTrainingSitterAllocationDataForAllocate,
  getTrainingCalendarDataForAllocate,
  trainingSitterAllocate,
} from '../../../common/api-service';

function TrainingAllocationPage() {
  const { rowData } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [eventsData, setEventsData] = useState([]);

  const getTrainingCalendarAllocationData = JSON.parse(localStorage.getItem('trainingCalenderData'));
  console.log('getTrainingCalendarAllocationData: ', getTrainingCalendarAllocationData);
  const [eData, setEData] = useState(getTrainingCalendarAllocationData);
  const [allocateData, setAllocateData] = useState([]);

  const TABLE_HEAD = [
    { id: 'user_name', label: 'User Name', alignRight: false },
    { id: 'book_services_id', label: 'Booking No', alignRight: false },
    { id: 'service_name', label: 'Service', alignRight: false },
    { id: 'date', label: 'Start Date', alignRight: false },
    { id: 'time_slot', label: 'Time Slot', alignRight: false },
    { id: 'number_of_pets', label: 'Number of Pets', alignRight: false },
    { id: 'number_of_sessions', label: 'Sessions', alignRight: false },
    { id: 'package_title', label: 'Package', alignRight: false },
    { id: 'target_pet', label: 'Pet Type', alignRight: false },
    { id: 'subscription', label: 'Subscription', alignRight: false },
    { id: '' },
  ];

  const handleAllocate = (card, index) => {
    const payload = {
      type: eData.service_name,
      sitter_id: card.sitters._id,
      _id: eData._id,
      book_service_id: eData.training_book_services_id,
    };
    return trainingSitterAllocate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        setAllocateData(data);
        localStorage.removeItem('getTrainingAllocationID');
        swal({
          title: res.data.message,
          icon: 'success',
          timer: 2000,
          button: false,
        });
        navigate('/dashboard/trainingSitterAllocation', { replace: true });
      } else {
        console.log('error');
      }
    });
  };

  const getTrainingAllocationID = () => {
    const getTrainingAllocationID = localStorage.getItem('getTrainingAllocationID');
    const getTrainingAllocationDate = localStorage.getItem('getTrainingAllocationDate');
    const selectedTrainingAllocationRow = localStorage.getItem('selectedTrainingAllocationRow');

    const payload = {
      service_master_id: getTrainingAllocationID,
      start_date: getTrainingAllocationDate,
    };
    return getTrainingSitterAllocationDataForAllocate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        console.log('data: ', data);
        setData(data);
      } else {
        console.log('error');
      }
    });
  };
  useEffect(() => {
    getTrainingAllocationID();
  }, []);

  const {
    formState: { errors },
  } = useForm({
    mode: 'all',
  });

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'auto',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
  };
  const [open, setOpen] = React.useState(false);

  const getTrainingCalendarID = () => {
    const getTrainingCalendarID = localStorage.getItem('getTrainingCalendarID');
    const payload = {
      sitter_id: getTrainingCalendarID,
    };
    if (getTrainingCalendarID) {
      return getTrainingCalendarDataForAllocate(payload).then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;
          setEventsData(data);
        } else {
          console.log('error');
        }
      });
    }
  };

  const handleClick = (sitter_id) => {
    localStorage.setItem('getTrainingCalendarID', sitter_id);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Page title="User">
        <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Training Sitter Allocation
          </Typography>
        </Stack>
          <Card>
            <EventCalendarListToolbar />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <EventCalendarListHead headLabel={TABLE_HEAD} rowCount={eData.length} />
                  <TableBody>
                    <TableRow hover key={eData.book_services_id} tabIndex={-1}>
                      <TableCell align="left">{eData.user_name}</TableCell>
                      <TableCell component="th" scope="row" padding="none">
                        {eData.training_book_services_id.slice(-4)}
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }} wordWrap>
                          {eData.service_name}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{moment(eData.date).format('YYYY-MM-DD')}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }} wordWrap>
                          {eData.time_slot}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.number_of_pets}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.number_of_sessions}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.package_title}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.target_pet}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.subscription === true ? 'Yes' : 'No'}</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        </Container>
      </Page>
      <Box sx={{ width: '100%' }}>
        <Grid container direction="row" spacing={2} sx={{ overflow: 'auto', minHeight: '80vh' }}>
          {data?.map((card, index) => (
            <Grid item xs={6}>
              <Card
                sx={{
                  margin: 2,
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <CardContent>
                    <Grid>
                      <Typography sx={{ fontWeight: 'bold' }}>{card.sitters.name}</Typography>
                    </Grid>
                    <Grid xs={1} sx={{ textAlign: 'justify' }}>
                      <Typography sx={{ textAlign: 'right', fontWeight: 'bold', mb: 1 }}>{card.city}</Typography>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6}>
                        {card.sessions.map((sessions) => (
                          <Typography>{sessions.time_slot}</Typography>
                        ))}
                      </Grid>
                      <Grid item xs={6}>
                        {card.service_master?.map((service) => (
                          <Typography>{service}</Typography>
                        ))}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Grid>
                <Grid sx={{ m: 1 }}>
                  <CardActions>
                    <Button variant="contained" onClick={() => handleAllocate(card, index)} size="small" sx={{ mr: 2 }}>
                      Allocate
                    </Button>
                    <Button
                      size="small"
                      onClick={() => {
                        handleClick(card.sitters._id);
                        getTrainingCalendarID();
                        return handleOpen();
                      }}
                    >
                      View Calender
                    </Button>
                  </CardActions>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Grid container>
          <Grid item xs={12}>
            <Button onClick={handleClose} color="error" sx={{ float: 'right' }}>
              X
            </Button>
          </Grid>
          <Grid item sx={{ mt: 1 }} xs={12}>
            <TrainingEventCalender eventsTrainingCalenderData={eventsData} allocateTrainingData={eData} />
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default TrainingAllocationPage;
